/**
 * VerticalStack Component
 * Layout component for consistent vertical spacing between elements
 */

import React, { type ReactNode } from 'react';
import { designTokens, type Spacing } from '../../constants/designTokens';

interface VerticalStackProps {
  children: ReactNode;
  spacing?: Spacing;
  align?: 'start' | 'center' | 'end' | 'stretch';
  className?: string;
  style?: React.CSSProperties;
}

export const VerticalStack = React.memo(function VerticalStack({
  children,
  spacing = 'lg',
  align = 'stretch',
  className = '',
  style,
}: VerticalStackProps) {
  return (
    <div
      className={`vertical-stack vertical-stack-${spacing} vertical-stack-align-${align} ${className}`}
      style={style}
    >
      {children}

      <style>{`
        .vertical-stack {
          display: flex;
          flex-direction: column;
          width: 100%;
        }
        
        /* Spacing variants */
        .vertical-stack-xs { gap: ${designTokens.spacing.xs}; }
        .vertical-stack-sm { gap: ${designTokens.spacing.sm}; }
        .vertical-stack-md { gap: ${designTokens.spacing.md}; }
        .vertical-stack-lg { gap: ${designTokens.spacing.lg}; }
        .vertical-stack-xl { gap: ${designTokens.spacing.xl}; }
        .vertical-stack-2xl { gap: ${designTokens.spacing['2xl']}; }
        .vertical-stack-3xl { gap: ${designTokens.spacing['3xl']}; }
        
        /* Alignment variants */
        .vertical-stack-align-start { align-items: flex-start; }
        .vertical-stack-align-center { align-items: center; }
        .vertical-stack-align-end { align-items: flex-end; }
        .vertical-stack-align-stretch { align-items: stretch; }
      `}</style>
    </div>
  );
});
